<template>
    <div class="box">
        <div class="nav" style="background-color: transparent;">
            <ul class="location">
                <li>
                     欢迎光临遵农共享
<!--                    <Dropdown placement="bottom-start">-->
<!--                        <a href="javascript:void(0)">-->
<!--                            <Icon type="ios-location" class="icon"></Icon> {{ city }}-->
<!--                        </a>-->
<!--                        <DropdownMenu slot="list" v-if="!isthsc">-->
<!--                            <div class="city">-->
<!--                                <p v-for="(items, index) in companyList" :key="index" style="color:#000000">-->
<!--                                    <span class="city-item" @click="changeCity(items)">{{ items.nickName }}</span>-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </DropdownMenu>-->
<!--                    </Dropdown>-->
                </li>
                <li>
                    <el-select style="width:110px;border: 1px ;" v-model="value" @change="selectLanguage" placeholder="请选择"
                        size="mini">
                        <el-option v-for="item in options" :key="item.code" :label="item.name" :value="item.code">
                        </el-option>
                    </el-select>
                </li>
            </ul>
            <div class="nav-div" style="display: flex;align-items: center;">
                <ul class="detail">
                    <li class="first" v-if="!userInfo.userName">
                        <a @click="tologo">{{ $t("nav.login") }} <Icon type="person"></Icon></a> &#12288;
                        <span class="text-color-red">
                            <a @click="toregister" style="color: #FF0101">{{ $t("nav.register") }} <Icon
                                    type="person-add"></Icon></a>
                        </span>
                    </li>
                    <li v-if="userInfo.userName">
                        <Dropdown>
                            <p class="username-p">
                                <img alt="" v-if="userInfo.headImg" :src="userInfo.headImg" class="user-avatar">
                                <Avatar v-else class="person-icon" icon="person" size="small" />
                                <span class="username">{{ userInfo.nickName }}</span>
                                <Icon class="username" type="ios-arrow-down" />
                            </p>
                            <DropdownMenu slot="list">
                                <div class="my-page">
                                    <div class="my-info" @click="myInfo">
                                        <Icon type="home"></Icon>
                                        <p>{{ $t("nav.personalCenter") }}</p>
                                    </div>
                                    <div class="sign-out" @click="signOutFun">
                                        <Icon type="log-out"></Icon>
                                        <p>{{ $t("nav.logOut") }}</p>
                                    </div>
                                </div>
                            </DropdownMenu>
                        </Dropdown>
                    </li>
                </ul>
                <span style="font-size: 12px;">{{ $t("nav.conNumber") }}：0315-6681288——{{ $t("nav.boss") }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import store from '@/vuex/store';
import { redirectToSsoPage, registerSsoPage } from '@/utils/sso'
import { getcompany, getCompanyPanel, getLanguageList } from '../../api/header'
import { mapState, mapActions } from 'vuex';
import { debounce } from 'lodash'; // 引入防抖函数

export default {
    name: 'M-Header',
    inject: ['reload'], // 保留注入，但仅在必要时使用
    created() {
        this.isLogin();
        // 初始化语言列表和公司列表（仅执行一次）
        this.initLanguageList();
        this.initCompanyList();
    },
    data() {
        return {
            city: '',
            companyList: [],
            companyId: '',
            isthsc: false,
            options: [],
            value: localStorage.getItem('lang') || 'zh', // 优先读取本地存储的语言
            langNewPanelList: []
        };
    },
    computed: {
        ...mapState(['userInfo'])
    },
    methods: {
        ...mapActions(['signOut', 'isLogin']),

        // 初始化语言列表（仅创建时执行）
        initLanguageList() {
            getLanguageList({}).then(res => {
                this.options = res.data || [];
                // 初始化语言（兼容$isthsc配置）
                if (this.$isthsc) {
                    this.value = 'en';
                    this.isthsc = true;
                } else {
                    this.value = localStorage.getItem('lang') || 'zh';
                    this.isthsc = false;
                }
                // 初始化页面语言和面板名称
                this.updatePageLanguage(this.value);
            });
        },

        // 初始化公司列表（防抖处理，避免重复请求）
        initCompanyList: debounce(function () {
            getcompany().then(res => {
                if (res.code === '0') {
                    this.companyList = res.data || [];
                    // 处理默认城市和公司ID
                    this.handleDefaultCityAndCompany();
                    // 请求面板列表
                    this.getCompanyPanelList();
                } else {
                    this.city = '';
                    this.companyId = '';
                }
            });
        }, 300),

        // 处理默认城市和公司ID
        handleDefaultCityAndCompany() {
            if (this.companyList.length === 0) return;

            // 优先读取本地存储的城市和公司ID
            const storedCity = localStorage.getItem("city");
            const storedCompanyId = localStorage.getItem("companyId");
            if (storedCity && storedCompanyId) {
                this.city = JSON.parse(storedCity);
                this.companyId = JSON.parse(storedCompanyId);
                return;
            }

            // 无本地存储时，按isthsc配置选择默认值
            if (this.isthsc === false) {
                // 查找id=1的公司，无则取第一个
                const targetCompany = this.companyList.find(item => item.id === 1) || this.companyList[0];
                this.city = targetCompany.nickName;
                this.companyId = targetCompany.id;
            } else {
                // 查找id=8的公司
                const targetCompany = this.companyList.find(item => item.id === 8);
                if (targetCompany) {
                    this.city = targetCompany.nickName;
                    this.companyId = targetCompany.id;
                } else {
                    this.city = this.companyList[0].nickName;
                    this.companyId = this.companyList[0].id;
                }
            }

            // 存储到本地
            localStorage.setItem("city", JSON.stringify(this.city));
            this.$addStorageEvent(1, 'companyId', JSON.stringify(this.companyId));
        },

        // 请求并更新面板列表（防抖处理）
        getCompanyPanelList: debounce(function () {
            if (!this.companyId) return;

            getCompanyPanel(this.companyId).then(res => {
                if (res.code === '0') {
                    let newPanelList = res.data.map(item => ({
                        id: item.id,
                        name: item.name
                    }));
                    // 根据当前语言添加固定面板
                    newPanelList = this.addFixedPanelsByLang(newPanelList);
                    this.langNewPanelList = newPanelList;
                    // 存储到本地，供其他组件使用
                    localStorage.setItem('newPanelList', JSON.stringify(newPanelList));
                    this.$addStorageEvent(1, 'newPanelList', JSON.stringify(newPanelList));
                }
            });
        }, 300),

        // 根据语言添加固定面板（首页、新闻资讯、关于我们）
        addFixedPanelsByLang(panelList) {
            const lang = this.value;
            let fixedPanels = [];

            switch (lang) {
                case 'en':
                    fixedPanels = [
                        { id: 998, name: 'front page' },
                        { id: 997, name: 'news' },
                        { id: 999, name: 'about us' }
                    ];
                    break;
                case 'ru':
                    fixedPanels = [
                        { id: 998, name: 'титульная страница' },
                        { id: 997, name: 'Новости' },
                        { id: 999, name: 'о нас' }
                    ];
                    break;
                default: // zh
                    fixedPanels = [
                        { id: 998, name: '首页' },
                        { id: 997, name: '新闻资讯' },
                        { id: 999, name: '关于我们' }
                    ];
                    break;
            }

            // 插入到面板列表（前面加首页，后面加新闻和关于我们）
            panelList.unshift(fixedPanels[0]);
            panelList.push(fixedPanels[1], fixedPanels[2]);
            return panelList;
        },

        // 语言切换处理（无reload，依赖响应式更新）
        selectLanguage() {
            this.updatePageLanguage(this.value);
            // 更新面板名称并重新请求面板列表（防抖）
            this.getCompanyPanelList();
        },

        // 更新页面语言
        updatePageLanguage(lang) {
            this.$i18n.locale = lang;
            localStorage.setItem('lang', lang);
            // 更新现有面板名称（无需刷新组件）
            this.updatePanelNamesByLang(lang);
        },

        // 根据语言更新面板名称
        updatePanelNamesByLang(lang) {
            this.langNewPanelList.forEach(item => {
                switch (item.id) {
                    case 998:
                        item.name = lang === 'en' ? 'front page' : lang === 'ru' ? 'титульная страница' : '首页';
                        break;
                    case 997:
                        item.name = lang === 'en' ? 'news' : lang === 'ru' ? 'Новости' : '新闻资讯';
                        break;
                    case 999:
                        item.name = lang === 'en' ? 'about us' : lang === 'ru' ? 'о нас' : '关于我们';
                        break;
                }
            });
            localStorage.setItem('newPanelList', JSON.stringify(this.langNewPanelList));
        },

        // 切换城市
        changeCity(city) {
            this.city = city.nickName;
            this.companyId = city.id;
            // 更新本地存储
            localStorage.setItem("city", JSON.stringify(this.city));
            this.$addStorageEvent(1, 'companyId', JSON.stringify(this.companyId));
            // 清除旧面板列表，重新请求
            localStorage.removeItem("newPanelList");
            this.getCompanyPanelList();
            // 跳转首页（无reload）
            this.$router.replace('/');
            sessionStorage.setItem("head_nav", 0);
        },

        // 个人中心
        myInfo() {
            this.$router.push({
                path: '/personalCenter',
                query: { user: this.userInfo }
            });
        },

        // 退出登录
        signOutFun() {
            this.signOut();
            // 退出时可调用reload重置状态
            this.reload();
        },

        // 跳转登录
        tologo() {
            redirectToSsoPage();
        },

        // 跳转注册
        toregister() {
            registerSsoPage();
        }
    },
    store
};
</script>

<style scoped>
/deep/.selected {
    color: #46B135 !important;
    background-color: rgba(70, 177, 53, 0.1);
}
/deep/ .hover {
    color: #46B135 !important;
}
/deep/ .el-input > input {
  background: transparent;
  color: #46B135;
}
/deep/ .el-select .el-input__inner:focus{
  border: none;
}
/deep/ .el-select .el-input.is-focus .el-input__inner{
    border: none;

}
/deep/ .el-input__inner{
  border: none;
}
.box {
    width: 100%;
    height: 35px;
    background-color: transparent;
    color: #4A4A4A !important;
}

.nav {
    margin: 0% auto;
    width: 65%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 35px;
    overflow: hidden;
}

.nav ul {
    list-style: none;
    color: #4A4A4A !important;
}

.nav li {
    float: left;
    font-size: 12px;
    line-height: 35px;
    margin-right: 15px;
}

.nav a {
    text-decoration: none;
     color: #4A4A4A !important;
    padding-left: 15px;
    border-left: 1px solid #ccc;
    cursor: pointer;
}

.location a {
    border-left: none;
}

.nav a:hover {
    color: #d9534f;
}

.location {
    color: #999999;
}

.icon {
    color: #4A4A4A !important;
}

.first {
     color: #4A4A4A !important;
}

.first a:first-child {
    padding-left: 3px;
    border-left: none;
}

.city {
    padding: 10px 15px;
}

.city-item {
    font-weight: bold;
    cursor: pointer;
    padding: 5px;
}

.city-item:hover {
    color: #d9534f;
}

.person-icon {
    color: #d9534f;
    background-color: #f0cdb2;
}

.username {
     color: #4A4A4A !important;
    margin-bottom: 10px;
}

.username-p {
    cursor: pointer;
    height: 35px;
    line-height: 35px;
}

.my-page {
    padding: 3px 5px;
    width: 180px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1111;
    color: #4A4A4A !important;
}

.my-page a {
    margin: 0px;
    padding: 0px;
    border: none;
}

.my-info {
    padding: 5px;
    width: 50%;
    height: 100%;
    text-align: center;
    cursor: pointer;
}

.my-info:hover {
    box-shadow: 0px 0px 5px #ccc;
}

.my-info i {
    font-size: 28px;
}

.my-info p {
    font-size: 12px;
}

.sign-out {
    padding: 5px;
    width: 50%;
    height: 100%;
    text-align: center;
    cursor: pointer;
}

.sign-out:hover {
    box-shadow: 0px 0px 5px #ccc;
}

.sign-out i {
    font-size: 28px;
}

.sign-out p {
    font-size: 12px;
}

.user-avatar {
    cursor: pointer;
    width: 25px;
    height: 25px;
    border-radius: 15px;
    display: inline;
    margin-top: 5px;
}

.nav-div {
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/header/headers.vue